// extracted by mini-css-extract-plugin
export default {"grid":"T9T_SPCoB86vjtDW2Yjo","slider":"Apssj1F0TlIonlWRfyc7","diffPositive":"o_fNv0eyXkAJAbaDD7uD","diffNegative":"CmRLlJ09dW0uhE3w07HG","input":"TmutvjnGCptcSaJ6ytyd"};